import { addNodeId } from '../utils/nodeIdPool';
import { getKnowledgeHitStatA } from '@/server/api';

const store = {
  namespaced: true,
  state: {
    knowledge: [],
    hitStats: {}, // { [knowledgeName]: { totalHit, percent } }
  },
  getters: {
    knowledgeHitStat: state => name => state.hitStats[name],
  },
  mutations: {
    SET_KNOWLEDGE_LIST(state, knowledge) {
      state.knowledge = knowledge.filter(item => !!item);
    },
    ADD_KNOWLEDGE(state, knowledge) {
      state.knowledge.push(knowledge);
    },
    UPDATE_KNOWLEDGE(state, knowledge) {
      const index = state.knowledge.findIndex(item => item.id === knowledge.id);
      if (index === -1) return
      state.knowledge.splice(index, 1, knowledge);
    },
    DEL_KNOWLEDGE(state, knowledgeId) {
      const index = state.knowledge.findIndex(item => item.id === knowledgeId);
      if (index === -1) return
      state.knowledge.splice(index, 1);
    },
    MODIFY_POSITION(state, { originalP = 0, newP = 0 }) {
      const data = state.knowledge[originalP];
      state.knowledge.splice(originalP, 1);
      state.knowledge.splice(newP, 0, data);
    },
    SET_HIT_STATS(state, hitStats) {
      state.hitStats = hitStats;
    },
  },
  actions: {
    setKnowledgeList({ commit }, knowledge) {
      commit('SET_KNOWLEDGE_LIST', knowledge)
    },
    // 拉取知识库命中统计
    fetchHitStats({ commit, rootState }, params = {}) {
      const sceneId = rootState.scene.sceneId;
      if (!sceneId) return Promise.resolve();
      return getKnowledgeHitStatA({
        flowId: sceneId,
        ...params,
      })
        .then(res => {
          if (res?.code !== 200) return;
          const map = {};
          (res.data || []).forEach(item => {
            map[item.knowledgeName] = {
              totalHit: item.totalHit,
              percent: item.percent,
            };
          });
          commit('SET_HIT_STATS', map);
        })
        .catch(() => {});
    },
    saveKnowledge({ commit, state, dispatch }, knowledge) {
      if (knowledge.id) {
        commit('UPDATE_KNOWLEDGE', knowledge)
      } else {
        knowledge.id = addNodeId('K');
        commit('ADD_KNOWLEDGE', knowledge)
      }
      return dispatch('scene/savePortionScene', { key: 'knowledge', data: state.knowledge }, { root: true })
    },
    // 批量添加
    saveKnowledges({ commit, state, dispatch }, knowledges) {
      for (let i = 0; i < knowledges.length; i++) {
        const knowledge = knowledges[i];
        knowledge.id = addNodeId('K');
        commit('ADD_KNOWLEDGE', knowledge)
      }
      return dispatch('scene/savePortionScene', { key: 'knowledge', data: state.knowledge }, { root: true })
    },
    delKnowledge({ commit, dispatch, state }, knowledgeId) {
      commit('DEL_KNOWLEDGE', knowledgeId);
      return dispatch('scene/savePortionScene', { key: 'knowledge', data: state.knowledge }, { root: true })
    },
    // 修改位置
    modifyPosition({ commit, dispatch, state }, positionInfo) {
      commit('MODIFY_POSITION', positionInfo);
      return dispatch('scene/savePortionScene', { key: 'knowledge', data: state.knowledge }, { root: true })
    },
  },
}
export default store
